// @ts-ignore
if (global.__UNIMODULES_DEPRECATION_WARNING_WAS_SHOWN) {
  console.warn(
    "Some of your dependencies are using deprecated '@unimodules/core' and '@unimodules/react-native-adapter'. Follow this guide to migrate: 'https://expo.fyi/expo-modules-migration'"
  );
  //@ts-ignore
  global.__UNIMODULES_DEPRECATION_WARNING_WAS_SHOWN = true;
}

export * from 'expo-modules-core';
